module.exports = __webpack_public_path__ + "a930f03c5d36bbd36097a5f1866a9a7f.fbx";